<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="设备ID" prop="deviceId" >
        <a-input v-model="form.deviceId" placeholder="请输入设备ID" />
      </a-form-model-item>
      <a-form-model-item label="摄像头开关：1开 0关" prop="cameraOn" >
        <a-input v-model="form.cameraOn" placeholder="请输入摄像头开关：1开 0关" />
      </a-form-model-item>
      <a-form-model-item label="扬声器静音：1静音 0正常" prop="speakerMute" >
        <a-input v-model="form.speakerMute" placeholder="请输入扬声器静音：1静音 0正常" />
      </a-form-model-item>
      <a-form-model-item label="麦克风开关：1开 0关" prop="micOn" >
        <a-input v-model="form.micOn" placeholder="请输入麦克风开关：1开 0关" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCameraSetting, addCameraSetting, updateCameraSetting } from '@/api/mibo/cameraSetting'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        deviceId: null,

        cameraOn: null,

        speakerMute: null,

        micOn: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        deviceId: [
          { required: true, message: '设备ID不能为空', trigger: 'blur' }
        ],
        cameraOn: [
          { required: true, message: '摄像头开关：1开 0关不能为空', trigger: 'blur' }
        ],
        speakerMute: [
          { required: true, message: '扬声器静音：1静音 0正常不能为空', trigger: 'blur' }
        ],
        micOn: [
          { required: true, message: '麦克风开关：1开 0关不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        deviceId: null,
        cameraOn: null,
        speakerMute: null,
        micOn: null,
        createTime: null,
        remark: null,
      }
                                  },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCameraSetting({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateCameraSetting(this.form).then(response => {

              if(response.success) {
                this.$message.success('修改成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '修改失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCameraSetting(this.form).then(response => {
              if(response.success) {
                this.$message.success('新增成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '新增失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
